import { Component } from '@angular/core';
import { TeamReportService } from './../../services/teamreport.service';
import { LoaddingService } from './../../providers/loadding.service';
import { UserReportModel } from './../../models/userreport.model';
import { StorageService } from './../../providers/storage.service';
import { PageDefault } from './../../pages/PageDefault';
import { TeamSearch } from './teamsearch';
import { ModalController } from 'ionic-angular';

/*
    团队报表
    TQQ 2016-12-28
*/
@Component({
    selector: "team-report",
    templateUrl: "teamreport.html",
    providers: [TeamReportService]
})

export class TeamReport {
    constructor(
        private teamreport: TeamReportService,
        private loadding: LoaddingService,
        private storage: StorageService,
        private modalCtrl: ModalController) { }

    modelList: UserReportModel[];
    currPage = 1;
    isHave = true;
    paras = new TeamReportInput();
    excludeTracks = [];
    load;
    hasmore = false;

    ionViewDidLoad() {
        this.load = this.loadding.showLoding();
        this.getTeamReport(this.paras).then(s => {
            this.loadding.closeLoading(this.load);
        });
    }

    //下拉重新加载
    //TQQ 2016-12-29
    doRefresh(refresher) {
        this.paras.PageIndex = 1;
        this.getTeamReport(this.paras).then(s => {
            refresher.complete();
        });
    }

    //上拉获取下一页信息
    //TQQ 2016-12-29
    doInfinite(infiniteScroll) {
        this.paras.PageIndex++;
        this.getTeamReport(this.paras).then(s => {
            infiniteScroll.complete();
        });
    }


    //查询条件
    //TQQ 2016-12-30
    presentFilter() {
        let modal = this.modalCtrl.create(TeamSearch, this.excludeTracks);
        modal.present();
        modal.onWillDismiss((data: any[]) => {
            if (data) {
                this.excludeTracks = data;
                this.paras.userName = this.excludeTracks["userName"];
                this.paras.StartDate = this.excludeTracks["startDate"];
                this.paras.EndDate = this.excludeTracks["endDate"];
                // this.getTeamReport(this.paras);
                this.ionViewDidLoad();
            }
        });

    }


    //获取团队报表信息
    //TQQ 2016-12-29
    getTeamReport(input: TeamReportInput) {
        return this.teamreport.getTeamReport(input.userName, input.StartDate, input.EndDate, input.PageIndex, input.PageSize).then(s => {
            if (s) {
                if (s.List.length == 0 && s.ListExt.length == 1) {
                    this.isHave = false;
                } else {
                    this.modelList = [];
                    this.modelList.push(s.ListExt[0]);
                    this.modelList = this.modelList.concat(s.List);
                    this.modelList.push(s.ListExt[1]);
                    if (s.List.length < s.PageCount) {
                        this.hasmore = true;
                    } else {
                        this.hasmore = false;
                    }
                }
            }
        }).catch(err => {
            console.log(err);
        });
    }


    //用户名点击事件
    //TQQ 2017-03-13
    userNameClick(username) {
        this.paras.userName = username;
        this.ionViewDidLoad();
    }

}


export class TeamReportInput {
    userName: string = "";
    StartDate: string = PageDefault.startDate();
    EndDate: string = PageDefault.endDate();
    PageIndex: number = PageDefault.PageIndex();
    PageSize: number = PageDefault.PageSize();
}



// WEBPACK FOOTER //
// ./src/pages/teamreport/teamreport.ts